<template>
    <div class="userList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input size clearable v-model="searchForm.terminal_sn" placeholder="请输入设备SN号"></el-input>
                </el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="searchForm.agent_no" placeholder="请输入所属代编号"></el-input>
				</el-form-item>
				<el-form-item>
				    <el-input size clearable v-model="searchForm.merchant_number" placeholder="请输入商户编号"></el-input>
				</el-form-item>
              <el-form-item>
                <el-input size clearable v-model="searchForm.title" placeholder="请输入调价政策名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input size clearable v-model="searchForm.up_code" placeholder="请输入调价政策编码"></el-input>
              </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.status"
                        clearable
                        placeholder="请选择审核状态"
                    >
					<el-option label="未审核" value="0"></el-option>
                        <el-option label="审核通过" value="1"></el-option>
                        <el-option label="审核拒绝" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(searchForm)"
                    >查询</el-button>
					<!-- <el-button
					    size="medium"
					    type="primary"
					    icon="el-icon-check"
					    style="font-size: 12px;"
					    @click="frozenDialog(1)"
					>批量审核</el-button> -->
					<el-button
					    size="medium"
					    type="primary"
					    icon="el-icon-delete"
					    style="font-size: 12px;"
					    @click="deletes(1)"
					>批量删除</el-button>
					<!-- <el-button size="medium" type="primary" icon="el-icon-plus" @click="addStock">批量导入调价终端信息</el-button> -->
                </el-form-item>
            </el-form>
        </el-card>
		
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
				<el-table-column
				      type="selection"
				      width="55">
				    </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="机器编号"
                    min-width="120"
                >
                </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="title"
                  label="调价政策名称"
                  min-width="150"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="up_code"
                  label="调价政策编码"
                  min-width="150"
              ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="new_base_rate"
                    label="上涨后的费率"
                    min-width="150"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="is_sec"
                    label="是否设置秒到费"
                    min-width="120"
                >
					<template slot-scope="scope">
					  <p>{{ scope.row.is_sec == 1?'是':'否'}}</p>
					</template>
				</el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="new_sec_fee"
                    label="秒到费收费金额(元)"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="添加时间"
                    min-width="150"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="商户名称"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="tel"
                    label="商户手机号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.tel | desMobile" placement="top">
                      <p>{{ scope.row.tel | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_number"
                    label="商户编号"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_name"
                    label="所属代理商"
                    min-width="120"
                ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="agent_no"
                  label="所属代理商编号"
                  min-width="120"
              ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_tel"
                    label="所属代理商手机号"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_tel | desMobile" placement="top">
                      <p>{{ scope.row.agent_tel | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="card_type_name"
                    label="卡类型"
                    min-width="150"
                ></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pay_type_name"
                    label="支付类型"
                    min-width="150"
                ></el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="status"
				    label="审核状态"
				    min-width="120"
				>
				<template slot-scope="scope">
				  <p>{{ scope.row.status_text}}</p>
				</template>
				</el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="examine_time"
				    label="审核时间"
				    min-width="150"
				>
				</el-table-column>
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="reason"
				    label="审核原因"
				    min-width="150"
				>
				</el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button @click="deletes(2,scope.row)" type="text" size="small">删除</el-button>
                        <el-button @click="frozenDialog(2,scope.row)" type="text" size="small" v-if="scope.row.status == 0">审核</el-button>

                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
                style="text-align: center"
            ></el-pagination>
        </el-card>
		<!--//导入-->
		      <stock-tools
		          v-if="toolsIsShow"
		          :toolsIsShow="toolsIsShow"
		          @toolsClose="toolsClose"
		      ></stock-tools>
		<!-- //批量冻结 -->
		<el-dialog
		    ref="blocked"
		    :visible="frozenState"
			@close="handleClose"
		    :close-on-click-modal="false"
		    title="审核"
		>
			<el-form label-position="right" label-width="80px" :model="frozenForm">
			  <el-form-item label="审核类型">
				<el-radio v-model="frozenForm.status" label="1">审核通过</el-radio>
				<el-radio v-model="frozenForm.status" label="2">审核拒绝</el-radio>
			  </el-form-item>
			  <el-form-item label="审核备注">
				<el-input type="textarea" v-model="frozenForm.reason" maxlength="100" placeholder="审核备注限100字，审核拒绝时必填"></el-input>
			  </el-form-item>
			  <el-button
				  type="primary"
				  :loading="frozenLoading"
				  style="font-size: 12px;"
				  @click="handleBlocked(frozenForm)"
			  >确认</el-button>
			
			  <el-collapse-transition>
				<el-form-item v-if="statusIsShow">
				<div class="titleTip">数据状态</div>
				<div class="tips">共计数据:{{dataStatus.count}}条</div>
				<div class="tips">成功数据:{{dataStatus.success}}条</div>
				<div class="tips">失败数据:{{dataStatus.error}}条</div>
				</el-form-item>
			  </el-collapse-transition>
			</el-form>
		</el-dialog>
    </div>
</template>

<script>
	import stockTools from './FM_stockTools';
export default {
    name: "UM_userList",
    data() {
        return {
            bankDetail: {
                isShow: false,
                row: {}
            },
            isEdit: 1,
            teamList: [],
            agentIsShow: false,
            signIsShow: false,
            blockedIsShow: false,
            userId: null,
            agentNo: null,
            rangeDate: '',
            searchForm: {
                page: 1,
                limit: 10,
            },
            userTable: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false,
            level: null,
			//批量冻结
			multipleSelection:[],
			frozenState:false,
			frozenForm:{
				status: '1',
				reason: ''
			},
			frozenLoading:false,
			statusIsShow:false,
			dataStatus: {
			  total: '', //总数
			},
			toolsIsShow:false,
			
        }
    },
    mounted() {
        this.level = sessionStorage.getItem('level')
        this.is_company = sessionStorage.getItem('is_company')
        this.getTeam();//获取所属分类
        this.getData({
            page: 1,
            limit: 10
        });
    },
	components: {
	    stockTools,
	},
    methods: {
		addStock() {
		  this.toolsIsShow = true;
		},
		toolsClose(ref) { //关闭导入、
		  this.toolsIsShow = false;
		  if (ref) { //重载表格
		    this.getData({
		      page: this.page.currentPage,
		      limit: this.page.pageSize
		    })
		  }
		},
		
		//勾选数据
		handleSelectionChange(val){
			this.multipleSelection = val;
		},
		
		//打开审核弹框
		frozenDialog(can,val){
			this.statusIsShow = false;
			this.dataStatus = {};
			if(can == 1){
				if(this.multipleSelection.length != 0){
					this.frozenState = true;
				}else{
					this.$message.error("请先勾选数据");
				}
			}else{
				this.frozenState = true;
				console.log(val)
				let data = [{id:val.id}]
				this.multipleSelection = data;
				console.log(this.multipleSelection)
			}
		},
		//关闭审核弹框
		handleClose() { //关闭结算信息修改
		    this.frozenState= false;
		    this.frozenForm = {
				status: '1',
				reason: ''
			};
			let params = this.searchForm;
			this.getData(params);
		},
		//确定审核
		handleBlocked() { 
			let data = {
				id_list:[],
				status:this.frozenForm.status,
				reason:this.frozenForm.reason,
			};
			var arr = [];
			this.multipleSelection.map(res=>{
				arr.push(res.id)
			})
			data.id_list = arr.join(',');
		    this.frozenLoading = true; //防重复
		    this.$api.post('terminal/DebitCardEquipmentAudit', data, res => {
				console.log(res)
		        if (res.code == 0) {
		            this.$message({
		                type: 'success',
		                message: res.msg,
		                duration: 2000,
		            })
					this.statusIsShow = true;
					this.dataStatus = res.data;
					let params = this.searchForm;
					this.getData(params);
					this.frozenLoading = false;
		        } else {
		            this.$message.error(res.msg);
		            this.frozenLoading = false;
		        }
		    })
		},
		//删除
		deletes(can,val){
			this.$confirm("确定删除?", '提 示', {
			    type: 'warning',
			    distinguishCancelAndClose: true,
			    confirmButtonText: '确 定',
			    cancelButtonText: '取 消'
			}).then(() => {
				if(can == 2){
					let data = [{id:val.id}]
					this.multipleSelection = data;
				}
				let data = {
					id_list:[],
					status:this.frozenForm.status,
					reason:this.frozenForm.reason,
				};
				var arr = [];
				this.multipleSelection.map(res=>{
					arr.push(res.id)
				})
				data.id_list = arr.join(',');
				this.frozenLoading = true; //防重复
				this.$api.post('terminal/DebitCardEquipmentDel', data, res => {
					console.log(res)
				    if (res.code == 0) {
				        this.$message({
				            type: 'success',
				            message: res.msg,
				            duration: 2000,
				        })
						let params = this.searchForm;
						this.getData(params);
						this.frozenLoading = false;
				    } else {
				        this.$message.error(res.msg);
				        this.frozenLoading = false;
				    }
				})
			}).catch(() => {
				
			})
		},
        handleSearch(searchForm) { //搜索
            this.currentPage = 1;
            searchForm.page = 1;
            this.getData(searchForm);
        },
		handleEditBankInfo(row) { // 结算信息修改
		    this.bankDetail.isShow = true;
		    this.bankDetail.row = row;
		},
		handleCloseBank(ref) { //关闭结算信息修改
		    this.bankDetail.isShow = false;
		    this.bankDetail.row = {};
		    if (ref) {
		        let params = this.searchForm;
		        this.getData(params);
		    }
		},
        addAgentDialog() { //添加代理弹窗
            this.agentIsShow = true;
        },
		addSignDialog(row) { //添加代理弹窗
			if (row.agent_no == null) {
				this.$message.error("请先实名认证");
			} else {
				this.agentNo = row.agent_no; //用户id
				this.signIsShow = true;
			}
        },
        handleAddAgent() { // 添加签约代理
            this.$router.push({ path: '/addUser' })
        },
        BlockedDialog(row) { //冻结弹窗
            this.userId = row.id; //用户id
            this.blockedIsShow = true;
        },
        handleInfo(row) { //详情
            this.$router.push({ path: '/userInfo', query: { id: row.id } });
        },
        //分页
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        getData(params) { //初始化数据
            this.loading = true;
            this.$api.post("terminal/DebitCardEquipmentList", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.userTable = data.list;
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        getTeam() { //获取所属分类
            this.$api.post('team_classification/team_classification', {}, res => {
                if (res.code == 0) {
                    this.teamList = res.data
                }
            })
        },
        authStatus(row) { //表格内容转换
            let auth_status;
            switch (row.auth_status) {
                case 1:
                    auth_status = "已实名";
                    break;
                case 0:
                    auth_status = "未实名";
                    break;
            }
            return auth_status;
        },
        agentClose(ref) { //关闭添加代理弹窗
            this.agentIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
		signClose(ref) { //关闭添加代理弹窗
		    this.signIsShow = false;
		    if (ref) {
		        this.getData({
		            page: this.currentPage,
		            limit: this.pageSize,
		        });
		    }
		},
        blockedClose(ref) { //关闭冻结用户弹窗
            this.blockedIsShow = false;
            if (ref) {
                this.getData({
                    page: this.currentPage,
                    limit: this.pageSize,
                });
            }
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.create_start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.create_end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        }
    }
};
</script>

<style lang="scss" scoped>
.userList {
}
</style>
